import React from "react";
import "./style.css";

const Paragraph = () => (
    <p className="paragraph">Kursy walut na podstawie tabeli nr 125/A/NBP/2020 of 2020-06-30 – <a
        rel="noreferrer noopener" target="_blank" href="https://nbp.pl/"
        title="Strona internetowa NBP">NBP</a>
    </p>
);

export default Paragraph;